import React from 'react'
import styled from 'styled-components'
import { size } from './platform'

export const MainMenu = styled((props: any) => (
  <div {...props}>{props.children}</div>
))`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;

  & > ul {
    > li > a {
      min-height: 32px;
    }
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
  }

  @media only screen and (max-width: ${size.md}) {
    width: fit-content;
    overflow-y: auto;
    height: calc(100vh - 230.5px);
    display: none;
    flex-direction: column;
    align-items: flex-start;
    & > ul {
      gap: 0px;
      flex-direction: column;
    }
  }

  @media only screen and (min-width: ${size.sm}) and (max-width: ${size.md}) {
    left: calc(100vw - 414px) !important;
    width: 414px !important;
  }
`
